module.exports = __webpack_public_path__ + "741c698a89129f35b6abc4c9af0c9756.mp3";